import { Colors } from 'elc-base-theme';

export const ratingTheme = `
    color: ${Colors.primary600};
    line-height: 0;
    font-weight: bold;
`;

export const starsWrapperTheme = `
    font-size: 24px;
    font-weight: bold;
`;

export const starTheme = `
    background-color: ${Colors.primary200};
`;

export const selectedStarTheme = `
    background-color: ${Colors.primary600};
`;

export const readReviewsTheme = `
    border-color: ${Colors.primary200};
`;

export const reviewsTextTheme = `
    color: ${Colors.primary600};
`;
